import axios from 'axios';
import { bundle } from '../../helpers';
import { handleErrors, paramBuilder, headerBuilder } from '../http';
export var fetchSpace = function fetchSpace() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Build URL and fetch the space.
  return axios.get(options.slug ? "/app/system-coordinator/components/core/app/api/v1/spaces/".concat(options.slug) : "".concat(bundle.apiLocation(), "/space"), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      space: response.data.space
    };
  })["catch"](handleErrors);
};
export var updateSpace = function updateSpace() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var space = options.space;

  if (!space) {
    throw new Error('updateSpace failed! The option "space" is required.');
  }

  return axios.put(options.slug ? "/app/system-coordinator/components/core/app/api/v1/spaces/".concat(options.slug) : "".concat(bundle.apiLocation(), "/space"), space, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      space: response.data.space
    };
  })["catch"](handleErrors);
};